import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { find, isNil, map, pathOr } from 'ramda'
import classnames from 'classnames'
import { getUrlComponent } from '../../utils'
import TransactionHOC from '../Reusable/TransactionHOC'
import NumberInput from '../../shared/components/NumberInput'
import DealmedListbox from '../../shared/components/DealmedListbox'
import Spinner from '../../shared/components/Spinner'
import DownChevronSVG from '../../shared/icons/DownChevronSVG'
import CheckmarkSVG from '../../shared/icons/CheckmarkSVG'
import ErrorSVG from '../../shared/icons/ErrorSVG'
import ShoppingBagSVG from '../../shared/icons/ShoppingBagSVG'
import PrescriptionSVG from '../../shared/icons/PrescriptionSVG'
import DealmedDialog from '../../shared/components/DealmedDialog'
import AddToItemListDropdown from '../ItemList/AddToItemListDropdown'
import CloseSVG from '../../shared/icons/CloseSVG'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { editCartDetail, removeCartDetail } from '../../actions'
import { useDispatch } from 'react-redux'
import CartHOC from '../Reusable/CartHOC'
import { formatReadableDate } from '../../utils/formatReadableDate'
import '../QuickOrder/QuickOrder.scss'
import { Col, Row } from 'reactstrap'
import { mixpanelLogEvent } from '../../utils/mixpanelLogEvent'

const { REACT_APP_STORAGE_URL, REACT_APP_CONT_PRODUCT_IMG, PUBLIC_URL } = process.env
const IMAGE_URL = REACT_APP_STORAGE_URL + REACT_APP_CONT_PRODUCT_IMG

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const QuickOrderItemCard = props => {
  const {
    children: itemChildren,
    displayName,
    id,
    itemId,
    isInStock,
    isAddableToCart,
    itemImage,
    itemName,
    manufacturer,
    mpn,
    quantityAvailable,
    rxLevel,
    price,
    siteDisplayName,
    thumbnailImage,
    unit,
    urlComponent,
  } = props.product

  const {
    validateRx,
    validateRxAndAddToCart,
    isPriceVisible,
    isAuthenticated,
    enhancedOrdering,
    showQuantityCounter,
    sectionTitle,
  } = props

  const productImage =
    thumbnailImage ||
    itemImage?.find(image => image.index == 1)?.largeUrl ||
    `${PUBLIC_URL}/images/imageComingSoon.png`
  const dispatch = useDispatch()
  const cartDetailForItem = props.cartDetail.filter(item => item.itemId === Number(id || itemId))
  // let units = map(unit => {
  //   return {
  //     value: unit.id,
  //     label: unit.unitName,
  //     conversionRate: unit.conversionRate,
  //     baseUnit: unit.baseUnit,
  //   }
  // }, pathOr([], ['units'], props.product))

  let units = map(unit => {
    return {
      value: unit.id,
      label: unit.unitName,
      conversionRate: unit.conversionRate,
      baseUnit: unit.baseUnit,
    }
  }, pathOr([], ['unit', 'details'], props.product))

  const search = window.location.search
  const params = new URLSearchParams(search)
  const uom = params.get('uom')
  const defaultUnit =
    (uom ? units.find(unit => unit.value == uom) : find(unit => unit.baseUnit, units)) || {}
  const unitDetails = enhancedOrdering
    ? units
    : findUnitDetails(props?.product?.latestPurchase?.unit)
  const previouslyOrderedDate = formatReadableDate(props?.product?.latestPurchase?.date)

  const [showDialog, setShowDialog] = useState(false)
  const [productQuantity, setProductQuantity] = useState(1)
  const [productUnits, setProductUnits] = useState(
    enhancedOrdering
      ? { name: 'Each', conversionRate: 1, id: unit ? unit.details[0].id : null }
      : {
          name: unitDetails.unitName,
          conversionRate: unitDetails.conversionRate,
          id: unitDetails.id,
        },
  )
  const [isAddingToCart, setIsAddingToCart] = useState(false)
  const [matrixItemDetails, setMatrixItemDetails] = useState(
    itemChildren?.length > 0
      ? {
          id: itemChildren[0].id,
          itemName: itemChildren[0].itemName,
          matrixDetails: itemChildren[0].matrixDetails,
          mpn: itemChildren[0].mpn,
          price: itemChildren[0].price,
          prices: itemChildren[0].prices,
          quantityAvailable: itemChildren[0].quantityAvailable,
          rxLevel: itemChildren[0].rxLevel,
          urlComponent: itemChildren[0].urlComponent,
        }
      : '',
  )
  const [number, setNumber] = useState(cartDetailForItem[0]?.quantity || 0)

  const productPath = getUrlComponent({ id, urlComponent })
  const { isValidRxLevel, isSellableCSL } = validateRx({ rxLevel })

  const productUOM = [{ value: 'Each', text: 'Each', disabled: false }]
  const productChildren = []
  let productPrice = formatter.format(
    (matrixItemDetails?.price || price) * productUnits.conversionRate * productQuantity,
  )

  if (unit) {
    for (const unit of unit.details) {
      if (unit?.unitName === 'Each') continue
      productUOM.push({ value: unit.unitName, text: unit.unitName, disabled: false })
    }
  }
  if (itemChildren?.length > 0) {
    for (const child of itemChildren) {
      productChildren.push({
        value: child.matrixDetails && Object.values(child.matrixDetails).join('/'),
        text: child.matrixDetails && Object.values(child.matrixDetails).join('/'),
        disabled: false,
      })
    }
    productChildren.sort((a, b) => a?.text?.localeCompare(b?.text))
  }
  const isMatrixItemAvailable = matrixItemDetails?.quantityAvailable > 0
  const isAvailable = props?.product?.quantityAvailable > 0

  function findUnitDetails(unitId) {
    const foundUnit = props?.product?.latestPurchase?.unitDetails?.find(unit => unit.id === unitId)
    return foundUnit
      ? {
          unitName: foundUnit.unitName || 'Each',
          conversionRate: foundUnit.conversionRate,
          id: foundUnit.id,
        }
      : {}
  }

  const getListPrice = (item, matrixItemDetails) => {
    if (matrixItemDetails?.prices) {
      for (let priceId in matrixItemDetails.prices) {
        if (matrixItemDetails.prices[priceId].level === 'List Price') {
          return matrixItemDetails.prices[priceId].price
        }
      }
    }

    for (let priceId in item.prices) {
      if (item.prices[priceId].level === 'List Price') {
        return item.prices[priceId].price
      }
    }
    return null
  }

  const listPrice = formatter.format(
    getListPrice(props.product, matrixItemDetails) * productQuantity,
  )

  const isPriceARange = price && price.toString().includes('-')
  const updateProductQuantity = quantity => {
    setProductQuantity(quantity)
  }

  const updateProductUnits = unitName => {
    const newUnits = unit?.details?.find(unit => unit.unitName === unitName)
    setProductUnits({
      id: newUnits.id,
      name: newUnits.unitName,
      conversionRate: newUnits.conversionRate,
    })
  }

  const updateProductByMatrixItem = newValue => {
    itemChildren.forEach(item => {
      if (Object.values(item.matrixDetails).join('/') == newValue) {
        setMatrixItemDetails({
          id: item.id,
          itemName: item.itemName,
          matrixDetails: item.matrixDetails,
          mpn: item.mpn,
          price: item.price,
          prices: item.prices,
          quantityAvailable: item.quantityAvailable,
          rxLevel: item.rxLevel,
          urlComponent: item.urlComponent,
        })
      }
    })
  }

  const logClickEvent = ({ eventType }) => {
    mixpanelLogEvent({
      eventType,
      userDetails: props?.auth?.user,
      itemDetails: props?.product,
    })
  }

  const addProductToCart = async () => {
    setIsAddingToCart(true)
    await validateRxAndAddToCart(
      matrixItemDetails.id ? { id: matrixItemDetails.id } : { id: id || itemId },
      productQuantity,
      productUnits.id || unitDetails.id,
    )
    logClickEvent({ eventType: `${sectionTitle}_Add_Item_To_Cart` })
    setIsAddingToCart(false)
  }

  const openDialog = () => {
    setShowDialog(true)
  }

  const closeDialog = () => {
    setShowDialog(false)
  }

  const getQuantityOfItemInCart = itemId => {
    const itemInCart = props.cartDetail.find(cartItem => cartItem.itemId === itemId)
    return itemInCart ? itemInCart.quantity : 0
  }

  useEffect(() => {
    itemChildren?.length > 0 &&
      setMatrixItemDetails({
        id: itemChildren[0].id,
        itemName: itemChildren[0].itemName,
        matrixDetails: itemChildren[0].matrixDetails,
        mpn: itemChildren[0].mpn,
        price: itemChildren[0].price,
        prices: itemChildren[0].prices,
        quantityAvailable: itemChildren[0].quantityAvailable,
        rxLevel: itemChildren[0].rxLevel,
        urlComponent: itemChildren[0].urlComponent,
      })
  }, [itemChildren])

  const isUnavailable = (!matrixItemDetails && price == 'N/A') || matrixItemDetails?.price == 'N/A'
  const hiddenPriceBool = isUnavailable || (!isAddableToCart && !isNil(isAddableToCart))

  return (
    <div
      className="quickorder__products-box"
      style={{
        maxWidth: '100%',
        borderRadius: '8px',
        width: '100%',
        padding: '0',
        minHeight: 'unset',
      }}
      key={props.key}
    >
      <Row
        className="quickorder__products-box-wrapper"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderBottomLeftRadius: '0px',
          borderBottomRightRadius: '0px',
          padding: '0px',
        }}
      >
        <Col>
          <div>
            {!enhancedOrdering && (
              <p className="previously-ordered-date">Prev. Ordered: {previouslyOrderedDate}</p>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Link to={`/product/${productPath}`}>
              <div
                className="quickorder__products-box-image-container"
                style={{ width: '120px', height: '120px' }}
              >
                <div
                  className="quickorder__products-box-image"
                  onClick={() => {
                    logClickEvent({ eventType: `${sectionTitle}_Item_Click` })
                    props.setShowAfterAddPage(false)
                  }}
                  style={{ maxWidth: '120px', maxHeight: '120px', minHeight: 'unset' }}
                >
                  <img
                    style={{ maxWidth: '100px', maxHeight: '100px' }}
                    src={productImage}
                    alt={siteDisplayName || displayName}
                    loading="lazy"
                  />
                </div>
              </div>
            </Link>
            {!hiddenPriceBool && (
              <div>
                {quantityAvailable > 0 || matrixItemDetails?.quantityAvailable > 0 ? (
                  <div></div>
                ) : (
                  <>
                    <div>
                      <span className="dealmed-product__availability-icon-wrapper">
                        <ErrorSVG className="dealmed-quickorder__availability-icon" />
                      </span>
                      <p className="dealmed-quickorder__availability-text">Out of Stock</p>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </Col>
        <Col
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            flexBasis: 'max-content',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px', width: '100%' }}>
            <div
              style={{
                backgroundColor: '#00AD84',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                padding: '4px 24px',
                borderRadius: '4px',
              }}
              className="flyInFromLeftWithBounce"
            >
              <CheckmarkSVG style={{ height: '12px', width: '16px' }} />
              <div>
                <p style={{ fontSize: '16px', color: 'white' }}> Added To Cart</p>
              </div>
            </div>
            <p
              style={{ fontSize: '16px', color: 'black', cursor: 'pointer' }}
              onClick={() => {
                logClickEvent({ eventType: `${sectionTitle}_AddMore_Click` })
                props.setShowAfterAddPage(false)
              }}
            >
              Add More?
            </p>
          </div>
          <div>
            <p className="quickorder__products-box-manufacturer">{manufacturer}</p>
            <Link to={`/product/${productPath}`}>
              <h5
                style={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  overflow: 'hidden',
                }}
                className="quickorder__products-box-title"
                onClick={() => {
                  logClickEvent({ eventType: `${sectionTitle}_Item_Click` })
                  props.setShowAfterAddPage(false)
                }}
                title={siteDisplayName || displayName}
              >
                {siteDisplayName || displayName}
              </h5>
            </Link>
          </div>
        </Col>
      </Row>

      {showQuantityCounter && getQuantityOfItemInCart(itemId) > 0 && (
        <p style={{ minHeight: '24px', textAlign: 'center' }}>
          `Added: ${getQuantityOfItemInCart(itemId)}`
        </p>
      )}
    </div>
  )
}

export default TransactionHOC(CartHOC(QuickOrderItemCard))
